import * as React from 'react'

export interface CenteredContentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  paddingTop?: number
  maxWidth?: number | string
  marginLeft?: number | string
  marginRight?: number | string
}

export class CenteredContent extends React.Component<CenteredContentProps, {}> {
  render() {
    const {
      paddingTop = 150,
      maxWidth = 450,
      marginLeft = 'auto',
      marginRight = 'auto',
      children,
      ...others
    } = this.props

    return (
      <div
        style={{
          paddingTop,
          maxWidth,
          marginLeft,
          marginRight,
        }}
        {...others}
      >
        {children}
      </div>
    )
  }
}
